import qs from 'query-string';
import { mobileAppBridge, uaParser } from '@encarpkg/shared';

export const makeGarageUrl = (param) => {
	const carHost = process.env.REACT_APP_ENCAR_FEM_CAR;
	const query = {
		tab: 'sell', // 내차팔기로 열기
		...(param.temporaryId && { temporaryId: param.temporaryId }),
		...(param.seqnum && { seqnum: param.seqnum }),
		...(param.sellerUniqueId && { sellerUniqueId: param.sellerUniqueId }),
	};

	return `${carHost}/cloned?${qs.stringify(query)}`;
};

// 내차고로 이동
export const moveToGarage = (url, useReplace = false) => {
	const garageUrl = url || makeGarageUrl({ temporaryId: '', seqnum: '' });
	if (uaParser().isApp) {
		mobileAppBridge().goEstimateIndex({ temporaryId: '' }, garageUrl);
		return;
	}
	if (useReplace) {
		window.location.replace(garageUrl);
	} else {
		window.location.href = garageUrl;
	}
};

// 차량전체보기에서 특정 차량 선택 후 내차고 이동
export const moveToGarageSelectedCar = (seqnum, sellerUniqueId) => {
	const garageUrl = makeGarageUrl({ seqnum, sellerUniqueId });

	if (uaParser().isApp) {
		mobileAppBridge().goEstimateIndex({ seqnum, sellerUniqueId }, garageUrl);
		return;
	}
	window.location.href = garageUrl;
};

export default {};
